








import Component from "vue-class-component";

import PageLayout from "@/common/layout/PageLayout.vue";
import { Page } from '@/layout/mixin/Page';

@Component({
  components: {
    PageLayout
  }
})
export default class SensorPage extends Page {
  title: string = "Sensor";
}
